import {
  Button,
  DatePicker,
  Empty,
  Popconfirm,
  Select,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { AppDispatch, RootState } from "../../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  DownloadOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import report from "../../../../apis/admin/report";
import notificationHandler from "../../../atoms/Notification";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import kitchenAdmin from "../../../../apis/admin/kitchenService";
import "./report.scss";

const MealReport = () => {
  const [date, setDate] = useState([]);
  const [dataReport, setDataReport] = useState<any>([]);
  const { RangePicker } = DatePicker;
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [ListKitchen, setListKitchen] = useState<any[]>([]);
  const [kitchenId, setListKitchenId] = useState<number>();
  const [dataSumPay, setDataSumPay] = useState<any>([]);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const [pageSize, setPageSize] = React.useState(10);

  const displayedIndex = (index: any) =>
    (currentPage - 1) * pageSize + index + 1;

  const { Title } = Typography;

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  React.useEffect(() => {
    kitchenAdmin
      .getKitchenData(1, "")
      .then((res: any) => {
        const data = res.data.data.payload;
        setListKitchen(data);
        
        const isOneOption = data?.length === 1;
        if (isOneOption) {
          setListKitchenId(data[0].id)
        }
      })
      .catch((err: any) => {
        notificationHandler("error", err?.response?.data?.data?.msg_content);
      });
    setLoading(true);
    report
      .searchStatisticsOrderByDay("", "", "", "" as any)
      .then((res: any) => {
        setDataReport(res.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", err?.response?.data?.data?.msg_content);
      })
      .finally(() => setLoading(false));
    report
      .searchStatisticsPaymentByDay("", "", "" as any)
      .then((res: any) => {
        if (res.data.data.payload) {
          setDataSumPay(res.data.data.payload);
        } else {
          setDataSumPay(null);
        }
      })
      .catch((err: any) => {
        setDataSumPay(null);
        notificationHandler("error", err?.response?.data?.data?.msg_content);
      })
      .finally(() => setLoading(false));
  }, []);

  dayjs.extend(customParseFormat);
  const dateFormat = "YYYY-MM-DD";
  const defaulttoDate: any = moment(dayjs("2023-05-01", dateFormat).toDate());
  const defaultformDate: any = moment(dayjs("2023-05-30", dateFormat).toDate());

  const onchangeDate = (date: any, dateString: any) => {
    setDate(dateString);
  };

  const exportExcel = (isDetail: number) => {
    setLoading(true);
    let kitId = kitchenId == undefined || kitchenId == 0 ? "" : kitchenId;
    report
      .statisticsOrderByDay(
        "EXCEL",
        date[0] || "",
        date[1] || "",
        kitId as any,
        isDetail
      )
      .then((res: any) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Báo cáo suất ăn theo ngày.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoading(false);
      })
      .catch((err: any) => {
        notificationHandler("error", "Xuất file exel không thành công");
        setLoading(false);
      });
  };
  const handleSearch = () => {
    let kitId = kitchenId == undefined || kitchenId == 0 ? "" : kitchenId;
    report
      .searchStatisticsOrderByDay(
        "",
        date[0] || "",
        date[1] || "",
        kitId as any
      )
      .then((res: any) => {
        setDataReport(res.data.data.payload);
      })
      .catch((err: any) => {
        notificationHandler("error", "Không tìm thấy dữ liệu");
        setDataReport(null);
      });
    report
      .searchStatisticsPaymentByDay(date[0] || "", date[1] || "", kitId as any)
      .then((res: any) => {
        if (res.data.data.payload) {
          setDataSumPay(res.data.data.payload);
        } else {
          setDataSumPay(null);
        }
      })
      .catch((err: any) => {
        setDataSumPay(null);
        notificationHandler("error", err?.response?.data?.data?.msg_content);
      })
      .finally(() => setLoading(false));
  };
  const paginationConfig = {
    showTotal: (total: any, range: any) =>
      `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
  };

  const onKitchenChange = (value: number) => {
    setListKitchenId(value);
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Bếp ăn",
      dataIndex: "kitchenName",
      key: "kitchenName",
      render: (value: any, record: any, index: number) => {
        return (
          <div className="truncates" key={index} title={value}>
            {value}
          </div>
        );
      },
    },
    {
      title: "Số suất ăn đã tặng",
      dataIndex: "numberOrderDonate",
      key: "numberOrderDonate",
    },
    {
      title: "Số suất ăn đã đặt thành công",
      dataIndex: "numberOrderSuccess",
      key: "numberOrderSuccess",
    },
    {
      title: "Số suất ăn đã thanh toán thành công",
      dataIndex: "numberOrderPaid",
      key: "numberOrderPaid",
      width: 400,
    },
  ];

  return (
    <div id="meal">
      <Spin indicator={antIcon} spinning={loading} />
      <div>
        <div className="flex justify-between my-3">
          <div className="flex w-[70%]">
            <RangePicker
              onChange={onchangeDate}
              placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
              format={dateFormat}
              locale={locale}
              className="w-[30%] cursor-pointer"
            />
            <Select
              className="w-[20%] ml-3"
              placeholder="Chọn bếp ăn"
              onChange={onKitchenChange}
              // allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input: string, option: any) =>
                (option?.label.toLowerCase() ?? "").includes(
                  input.trim().toLowerCase()
                )
              }
              options={ListKitchen?.map((item: any, key: number) => ({
                value: item.id,
                label: item.kitchenName,
              }))}      
              value={kitchenId}        
            ></Select>
            <Button
              icon={<SearchOutlined />}
              // loading={loading}
              onClick={handleSearch}
              className="ml-3 text-white bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
            >
              Tìm kiếm
            </Button>
            <Button
              type="primary"
              className="ml-3 text-white bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
              icon={<DownloadOutlined />}
              onClick={() => {
                exportExcel(0);
              }}
            >
              Xuất báo cáo
            </Button>
          </div>

          <Button
            type="primary"
            className="text-white bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
            icon={<DownloadOutlined />}
            onClick={() => {
              exportExcel(1);
            }}
          >
            Xuất báo cáo chi tiết
          </Button>
        </div>
      </div>
      <Title className="mt-[20px]" level={3}>
        Danh sách suất ăn
      </Title>
      {dataSumPay && (
        <div className="mt-[10px]">
          <p className="mt-[5px] text-lg	text-[#50d71e]">
            Tổng suất ăn thanh toán thành công:{" "}
            {dataSumPay ? dataSumPay[0]?.numberPaymentSuccess : 0}
          </p>
          <p className="mt-[5px] text-lg	text-[#ff3737]">
            Tổng suất ăn thanh toán thất bại:{" "}
            {dataSumPay ? dataSumPay[0]?.numberPaymentFail : 0}
          </p>
        </div>
      )}
      <Table
        dataSource={dataReport}
        columns={columns}
        pagination={{
          locale: { items_per_page: "bản ghi / Trang" },
          current: currentPage,
          defaultPageSize: 10,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          onShowSizeChange(current, size) {
            setPageSize(size);
          },
          showTotal: (total: any, range: any) =>
            `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
        }}
        rowKey={(record: any) => record.id}
        className="mt-[15px]"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_DEFAULT}
              description="Không có dữ liệu!"
            />
          ),
        }}
      />
    </div>
  );
};

export default MealReport;
